import React from 'react';
import '../../styles/Template3.css';
import logo from '../../uploads/logo.png';
import avatar from '../../uploads/avatar.png';
import earth from '../../uploads/earth.png';

const Template3 = ({ formData, educationData, languageData, computerSkillsData, employmentData, registrationAddress }) => {
    const imageUrl = formData.Photo ? `data:image/jpeg;base64, ${formData.Photo}` : avatar;
	let birthPlace = `${formData.BirthPlace.Country.Name ? formData.BirthPlace.Country.Name : ''}${formData.BirthPlace.City ? `, ${formData.BirthPlace.City}` : ''}`;
    const reversedEmploymentData = employmentData.slice().reverse();
    const formatDate = (date) => {
        const rawDate = date.split('T')[0];
        const dateParts = rawDate.split('-');
        return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
    }

    const isObjectEmpty = (data) => {
        for (const item of data) {
            for (const key in item) {
                if (typeof item[key] === 'object') {
                    const subItem = item[key];
                    for (const subKey in subItem) {
                        if (subItem[subKey] !== '') {
                            return false;
                        }
                    }
                } else if (item[key] !== '') {
                    return false;
                }
            }
        }
        return true;
    };

	return (
		<>
		<div className="template3-container">
            <div className='avatar-box'>
                <img src={imageUrl} className='avatar' alt='avatar' />
            </div>
            <h1>{formData.Name}</h1>
            <div className='content-box-left'>
                <div className='content-box-left-item'>
                    <h3>о себе</h3>
                </div>
                <div className='content-box-left-item'>
                    <h3>контактная информация</h3>
                    <p>Моб. тел: {formData.MobilePhoneWork.value}</p>
                    <p>Электронная почта: {formData.EmailPersonal}</p>
                    <p>Адрес: {registrationAddress.ViewAddresses}</p>
                </div>
                <div className='content-box-left-item'>
                    <h3>знание языков</h3>    
                    {!isObjectEmpty(languageData) && languageData.map((lang, index) => (
                        <p key={`lang${index}`}>{lang.Language.Name} - {lang.LanguageDegree.Name}</p>                    
                    ))}                
                </div>
                <div className='content-box-left-item'>
                    <h3>компьютерные навыки</h3>
                    {!isObjectEmpty(computerSkillsData) && computerSkillsData.map((skill, index) => (
                        <p key={`comp${index}`}>{skill.Software.Name} - {skill.SoftwareLevel.Name}</p>
                    ))}
                </div>
            </div>
            <div className='content-box-right'>
                <div className='content-box-right-item'>
                    <h3>опыт работы</h3>
                    {!isObjectEmpty(reversedEmploymentData) && reversedEmploymentData.map((employment, index) => (
                        <div key={`emp${index}`} className='content-box-right-employment-item'>
                            <h4>{employment.Position}</h4>
                            <h5>{employment.Organization} | С {formatDate(employment.EmploymentDate)} по {employment.DismissalDate ? formatDate(employment.DismissalDate) : 'Н.В.'}</h5>
                            <p>{employment.Duties}</p>
                        </div>                  
                    ))}
                </div>
                <div className='content-box-right-item'>
                    <h3>образование</h3>
                    {!isObjectEmpty(educationData) && educationData.map((edu, index) => (
                        <div key={`edu${index}`} className='content-box-right-education-item'>
                            <h4>{edu.Institution.Name}</h4>
                            <h5>{edu.Faculty} | С {formatDate(edu.Start)} по {formatDate(edu.End)}</h5>
                        </div>
                    ))}
                </div>
            </div>
        </div>
		</>
	);
};

export default Template3;
